import * as Mod1 from "./discourse/components/ad-component";
import * as Mod2 from "./discourse/components/ad-slot";
import * as Mod3 from "./discourse/components/adbutler-ad";
import * as Mod4 from "./discourse/components/amazon-product-links";
import * as Mod5 from "./discourse/components/carbonads-ad";
import * as Mod6 from "./discourse/components/google-adsense";
import * as Mod7 from "./discourse/components/google-dfp-ad";
import * as Mod8 from "./discourse/components/house-ad";
import * as Mod9 from "./discourse/components/nested-root-ad";
import * as Mod10 from "./discourse/components/post-bottom-ad";
import * as Mod11 from "./discourse/connectors/after-topic-list-item/discourse-adplugin.gjs";
import * as Mod12 from "./discourse/connectors/discovery-list-container-top/discourse-adplugin.gjs";
import * as Mod13 from "./discourse/connectors/topic-above-post-stream/discourse-adplugin.gjs";
import * as Mod14 from "./discourse/connectors/topic-above-suggested/discourse-adplugin.gjs";
import * as Mod15 from "./discourse/helpers/slot-position";
import * as Mod16 from "./discourse/initializers/adplugin-admin-plugin-configuration-nav";
import * as Mod17 from "./discourse/initializers/initialize-ad-plugin";
const compatModules = {
  "discourse/components/ad-component": Mod1,
  "discourse/components/ad-slot": Mod2,
  "discourse/components/adbutler-ad": Mod3,
  "discourse/components/amazon-product-links": Mod4,
  "discourse/components/carbonads-ad": Mod5,
  "discourse/components/google-adsense": Mod6,
  "discourse/components/google-dfp-ad": Mod7,
  "discourse/components/house-ad": Mod8,
  "discourse/components/nested-root-ad": Mod9,
  "discourse/components/post-bottom-ad": Mod10,
  "discourse/connectors/after-topic-list-item/discourse-adplugin": Mod11,
  "discourse/connectors/discovery-list-container-top/discourse-adplugin": Mod12,
  "discourse/connectors/topic-above-post-stream/discourse-adplugin": Mod13,
  "discourse/connectors/topic-above-suggested/discourse-adplugin": Mod14,
  "discourse/helpers/slot-position": Mod15,
  "discourse/initializers/adplugin-admin-plugin-configuration-nav": Mod16,
  "discourse/initializers/initialize-ad-plugin": Mod17,
};
export default compatModules;
